export default __webpack_public_path__ + "static/media/smallblue.76a4106d.png";